export default __webpack_public_path__ + "static/terence2-f7f6d4d33dca80ab3b87f1010c9e73a4.jpg";